module.exports = __webpack_public_path__ + "media/images/patent/z_2-de622be5d1f0d2aeaf50c4c0dffb77f5.png";